import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User, UserRole } from '../generated/graphql';

export type ClientPodUserRole = 'GOVERNMENT_SOLUTIONS' | 'ENERGY' | 'OTHER';

export interface UserState {
  id: string | null;
  username: string | null;
  email: string | null;
  picture: string | null;
  roles?: UserRole[] | null;
  profile?: User['profile'] | null;
}

const initialState: UserState = {
  id: null,
  username: null,
  email: null,
  picture: null,
  roles: null,
  profile: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<UserState>) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setUser } = userSlice.actions;

export const userReducer = userSlice.reducer;
